<div class="iching-cast" [class.iching-cast--compact]="compact()">
  <div class="iching-cast__toggles">
    <e-segmented-toggle
      testId="iching-mode"
      size="md"
      [options]="modeOptions()"
      [value]="mode()"
      (valueChange)="modeChange.emit($event)"
    />
    @if (mode() === 'coins') {
      <e-segmented-toggle
        testId="iching-distribution"
        size="xs"
        [options]="distributionOptions()"
        [value]="distribution()"
        (valueChange)="distributionChange.emit($event)"
      />
    }
  </div>

  @switch (mode()) {
    @case ('coins') {
      <div class="iching-cast__stage iching-cast__stage--ledger">
        <div class="iching-cast__throw">
          @if (distribution() === 'coins') {
            <hd-iching-coin-throw [faces]="lastFaces()" />
          }
          <button
            type="button"
            class="iching-cast__throw-btn"
            data-test-id="iching-throw"
            [disabled]="complete()"
            (click)="throwLine()"
          >
            @if (complete()) {
              {{ t('humanDesign.iching.cast.throwDone') }}
            } @else {
              {{ t('humanDesign.iching.cast.throwLine', { line: lines().length + 1 }) }}
            }
          </button>
          @if (lastValueText(); as text) {
            <p class="iching-cast__last" aria-live="polite">{{ text }}</p>
          }
        </div>
        <hd-iching-cast-ledger class="iching-cast__ledger" mode="coins" [lines]="lines()" [coinFaces]="coinFaces()" />
      </div>
    }

    @case ('manual') {
      <p class="iching-cast__hint">{{ t('humanDesign.iching.cast.manualHint') }}</p>
      <div class="iching-cast__stage iching-cast__stage--ledger">
        <div class="iching-manual">
          @for (row of manualRows(); track row.position) {
            <div class="iching-manual__row" [attr.data-line]="row.position">
              <span class="iching-manual__position">{{ row.position }}</span>
              <e-segmented-toggle
                testId="iching-manual"
                size="sm"
                [options]="row.options"
                [value]="row.value"
                (valueChange)="setManual($event)"
              />
            </div>
          }
        </div>
        <hd-iching-cast-ledger class="iching-cast__ledger" mode="manual" [lines]="manualLedgerLines()" />
      </div>
    }

    @case ('direct') {
      <div class="iching-direct">
        <hd-iching-hexagram-matrix [selected]="directHexagram()" (hexagramSelected)="pickHexagram($event)" />
        <div class="iching-direct__controls">
          <label class="iching-direct__number">
            <span>{{ t('humanDesign.iching.cast.directNumber') }}</span>
            <input
              #numberInput
              type="number"
              min="1"
              max="64"
              inputmode="numeric"
              data-test-id="iching-direct-number"
              [value]="directHexagram() ?? ''"
              (change)="pickNumber(numberInput.value)"
            />
          </label>
          <fieldset class="iching-direct__moving">
            <legend>{{ t('humanDesign.iching.cast.movingLines') }}</legend>
            @for (position of positions; track position) {
              <label class="iching-direct__moving-option">
                <input
                  #movingBox
                  type="checkbox"
                  [attr.data-moving]="position"
                  [checked]="directMoving().includes(position)"
                  (change)="toggleMoving(position, movingBox.checked)"
                />
                {{ position }}
              </label>
            }
          </fieldset>
          @if (lines().length === 6 && directHexagram() !== undefined) {
            <hd-iching-cast-ledger class="iching-cast__ledger" mode="direct" [lines]="lines()" />
          }
        </div>
      </div>
    }
  }

  @if (mode() !== 'direct') {
    @if (legend(); as l) {
      <aside class="iching-cast__legend">
        <p class="iching-cast__legend-coins">{{ l.head }} · {{ l.tail }}</p>
        <dl class="iching-cast__legend-values">
          @for (entry of legendValues(); track entry.value) {
            <div>
              <dt>{{ entry.value }}</dt>
              <dd>{{ entry.text }}</dd>
            </div>
          }
        </dl>
        <p>{{ l.order }}</p>
        <p class="iching-cast__legend-interrupt">{{ l.interrupt }}</p>
      </aside>
    }
  }
</div>
